import { doc, onSnapshot } from "firebase/firestore"
import { notifyDocumentAsDeleted } from "../components/global/DeletedDocumentManager"
import { db } from "../firebase/firebase"
import { queryClient } from "../main"
import { FirestoreDocument } from "../types/firestoreDocument"
import { dexie } from "./localDatabase"
import { documentConverters, unsubsribersForObservedThings } from "./myFreeReads"
import { logger } from "@/utils/logger"

export async function startObserveDocument(collectionName: string, id: string) {
   const unsubcriberKey = collectionName + "/" + id

   if (unsubsribersForObservedThings.has(unsubcriberKey)) {
      return true
   }
   logger(`Start Observe Document ${collectionName}/${id}`)
   unsubsribersForObservedThings.set(unsubcriberKey, () => {})
   const docRef = doc(db, collectionName, id)

   const unsubscribe = onSnapshot(docRef, (doc) => {
      logger(`Document ${collectionName}/${doc.id} was changed`)
      let docWasDeleted = false

      if (doc.exists()) {
         const data = doc.data()

         let formattedData: FirestoreDocument = {
            ...data,
            id: doc.id,
            created_at: data.created_at?.toDate(),
            updated_at: data.updated_at?.toDate(),
            updated_by: data.updated_by,
            is_deleted: data.is_deleted,
         }

         // Apply custom converter if exists
         const converter = documentConverters.get(collectionName)
         if (converter) {
            formattedData = converter(formattedData)
         }

         dexie.table(collectionName).put(formattedData)

         docWasDeleted = formattedData.is_deleted === true
      } else {
         docWasDeleted = true
      }

      if (docWasDeleted) {
         dexie.table(collectionName).delete(doc.id)
         notifyDocumentAsDeleted(collectionName, doc.id)
      }

      queryClient.invalidateQueries({
         queryKey: ["document", collectionName, doc.id],
      })

      queryClient.invalidateQueries({
         queryKey: ["collection", collectionName],
      })
   })

   unsubsribersForObservedThings.set(unsubcriberKey, unsubscribe)
}
